import WatermarkSection from './WatermarkSection.component';

export default WatermarkSection;
